import React, { useEffect } from 'react';
import Lottie from "lottie-react";
import {withTranslation} from "react-i18next";
import vrImg from "../../../../assets/course_img/vr_step_icon.svg";
import {Button, Col, Row, Container, ListGroup, Image,Spinner,Alert  } from 'react-bootstrap';


function VRTrainingProcessed(props) {    
    let updateStatusTimer = null;
    let statusList = {
        1:{name:"start",text:props.t("Practical assignment started"),type:"success"},
        3:{name:"paused",text:props.t("The practical assignment has been suspended"),type:"info"},
        4:{name:"waiting",text:props.t("Waiting to start in a virtual reality helmet"),type:"warning"},
        5:{name:"continued",text:props.t("Completion of the practical assignment continued"),type:"info"},
        6:{name:"canceled",text:props.t("Practical assignment canceled"),type:"danger"},
        7:{name:"queued",text:props.t("You are in line to complete a practical assignment, wait for the queue to clear."),type:"info"},
        8:{name:"error",text:props.t("Error starting a practical assignment"),type:"danger"},
        10:{name:"end",text:props.t("The practical assignment is completed"),type:"success"}
    };
    const checkStatus = ()=>{
        props.handleCheckActualStatus();
    }
    useEffect(()=>{
        updateStatusTimer = setTimeout(()=> {
            checkStatus();
        }, 30000);

        return ()=>{
            clearTimeout(updateStatusTimer);
        }
    });
    const renderStatus = () =>{                        
        let status = statusList[props.currentTrainingStatus];
        return <Alert  key={status.type} variant={status.type}   style={{fontSize:"16pt"}} className='w-100'>{status.text}</Alert >
    }
    return <div className="preshift d-flex align-items-center flex-column justify-content-center h-100">
                <Container>
                    <Row className="align-items-center">
                        <Col xl={6} lg={6} xs={12} sm={12}>
                            <Image src={vrImg} alt={props.t('VR training icon')} className='w-100'/>
                        </Col>
                        <Col  xl={6} lg={6} xs={12} sm={12}>
                            <ListGroup style={{fontSize:"16pt"}}>
                                <ListGroup.Item style={{ border: "none"}}>1. {props.t("Put on virtual reality glasses")}</ListGroup.Item>
                                <ListGroup.Item style={{ border: "none"}}>2. {props.t("Take the joysticks in your hands")}</ListGroup.Item>
                                <ListGroup.Item style={{ border: "none"}}>3. {props.t("With the glasses on, click on the 'Start' button")}</ListGroup.Item>
                                <ListGroup.Item style={{ border: "none"}}>4. {props.t("When finished, click on the 'Save result' button")}</ListGroup.Item>
                                <ListGroup.Item style={{ border: "none"}}>5. {props.t("Go back to completing the e-course")}</ListGroup.Item>
                            </ListGroup>
                        </Col>
                    </Row>
                    <Row  className="align-items-center mt-5" >
                        <Col  xl={4} lg={4} xs={6} sm={6}>
                            <h3 style={{fontSize:"24pt"}}>{props.t("Current status of the passage")}:</h3>
                        </Col>
                        <Col xl={8} lg={8} xs={6} sm={6}>
                            <Row className="align-items-center" style={{padding:"0"}}>
                                <Col  xl={8} lg={8} xs={8} sm={8} style={{margin:"0",padding:"0"}} className='w-100'>
                                    {renderStatus()}
                                </Col>
                                <Col  xl={4} lg={4} xs={4} sm={4} style={{margin:"0",padding:"0"}}>
                                
                                    {(props.loadStatus)?
                                        <Button style={{"padding":"35px",fontSize:"30px"}} className="MuiButton Btn Btn_success btn btn-primary text-center" disabled>
                                            <Spinner
                                            as="span"
                                            animation="grow"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            />
                                            <span className="text-center">{props.t('Check status')}</span>
                                        </Button>
                                    :
                                        <Button style={{"padding":"35px",fontSize:"30px"}} className="MuiButton Btn Btn_success btn btn-primary text-center" onClick={checkStatus}   >                                
                                            <span className="text-center">{props.t('Check status')}</span>
                                        </Button>        
                                            }                            
                                
                                </Col>
                                </Row>
                        </Col>
                        
                    </Row>

                </Container>
            
           </div>
}
export default withTranslation()(VRTrainingProcessed);